import duplicateEstimateGroup from '../../../Services/duplicateEstimateGroup';

export default (params) => async (dispatch) => dispatch(duplicateEstimateGroup(params))